import { getTrackById } from "../assets/asset_loaders/tracks";

/**
 * Takes World tracks from Firestore DB and converts them into a format
 * the World Cup display components can render.
 * @param {Array} tracks - Array of track objects with {start, end} from Firestore
 * @returns {Array} - Array of track objects with full track data
 */
export default function getWorldTracks(tracks) {
  return tracks.map(track => {
    const startTrack = getTrackById(track.start);
    const endTrack = track.end ? getTrackById(track.end) : null;

    return {
      start: track.start,
      end: track.end,
      startTrack: startTrack,
      endTrack: endTrack
    };
  });
}
